function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

function toggleTargetAttribute(cardLink) {
  const cardURL = cardLink.attr('href');
  const isLocalUrlCheck = isLocalUrl(cardURL);
  if (isLocalUrlCheck) {
    cardLink.removeAttr('target');
  }
}

function removeLink(data, x, item) {
  const { URL, PurchaseURL } = data.items[x];
  const links = PurchaseURL || URL;
  if (links === null) {
    item.removeAttr('href');
    item.removeAttr('target');
  }
}

function modifyLinkBehavior(widgetData, cards) {
  cards.each(function (x) {
    const card = $(this);
    if (card.hasClass('void-link')) {
      removeLink(widgetData, x, card);
    } else {
      toggleTargetAttribute(card);
    }
  });
}

export { modifyLinkBehavior };
